const DataFormat = {
	JSON: "JSON",
	CSV: "CSV",
	PNG: "PNG",
	JPG: "JPG",
	PDF: "PDF"
};
export default DataFormat;
